var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 483.56 492.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0F5283;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.37,661.75c-.75-10.95-1.5-21.39-2.18-31.83-1.35-20.78-2.61-41.57-4-62.34A9.33,9.33,0,0,1,44,559.65Q180.65,418.85,317.16,277.9c4.38-4.52,8.6-9.21,13.43-14.38L438.73,368,339.15,470.74Q245.91,567,152.73,663.22a11.39,11.39,0,0,1-10,3.86c-28.77-1.75-57.56-3.2-86.34-4.75C53.48,662.17,50.53,662,47.37,661.75Z",
    transform: "translate(-41.1 -174.77)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.09,238.67c5.09-4.46,10-8.26,14.3-12.63,14.73-15,29.21-30.15,43.88-45.17,7.87-8.06,17.46-8.11,25.56-.27q40.59,39.27,81.12,78.6c8.81,8.55,9,17.81.45,26.61-18.63,19.28-37.3,38.52-56.49,58.32Z",
    transform: "translate(-41.1 -174.77)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a850527f.svg";
export { ForwardRef as ReactComponent };